// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { configureBudgetStyles } from "@conklin/Overrides/Widgets/Budget/ConfigureBudget";
import { color, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { RadioGroupStyle } from "@insite/mobius/RadioGroup";
import { css } from "styled-components";

configureBudgetStyles.gridContainer = {
    gap: 0,
};

configureBudgetStyles.startDatePicker = {
    cssOverrides: {
        datePicker: css`
            width: 100%;
            .react-datetime-picker__calendar {
                z-index: 1263;
            }
        `,
    },
};

configureBudgetStyles.budgetYearGridItem = {
    width: 12,
    css: css`
        padding-top: 7px;
        padding-bottom: 0;
    `,
};

configureBudgetStyles.budgetYearEndGridItem = {
    width: 12,
    css: css`
        display: flex;
        align-items: flex-end;
        padding: 9px 0 8px;
        ${xScreen("lte", "sm")} {
            display: block;
            padding-bottom: 10px;
        }
        ${xScreen("gt", "md")} {
            ${RadioGroupStyle} legend {
                margin-bottom: 0;
            }
        }
    `,
};

configureBudgetStyles.budgetPeriodTitle = {
    variant: "h5",
    css: css`
        display: inline-block;
        margin: 0 6px 0 0;
    `,
};

configureBudgetStyles.gridItems = {
    css: css`
        align-items: center;
        padding: 11px 0;
    `,
};

configureBudgetStyles.titleGridItems = {
    width: [12, 7, 8, 8, 8],
    css: css`
        align-items: center;
        padding: 20px 0 15px;
    `,
};

configureBudgetStyles.titleText = {
    variant: "h2",
};

configureBudgetStyles.customBudgetPeriodInput = {
    type: "number",
    min: 1,
    max: 13,
    cssOverrides: {
        formField: css`
            width: 55px;
            display: inline-block !important;
            margin-right: 20px;
            margin-top: 10px;
        `,
        inputSelect: css`
            padding-right: 5px;
            &:focus {
                padding-right: 5px;
            }
        `,
    },
};

configureBudgetStyles.buttonsGridItem = {
    width: [12, 5, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        padding: 20px 0 15px;
        ${xScreen("lte", "sm")} {
            padding-top: 0;
        }
    `,
};

configureBudgetStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-top: 2px;
        ${xScreen("lte", "sm")} {
            width: 50%;
            margin-top: 0;
        }
    `,
};

configureBudgetStyles.saveButton = {
    css: css`
        margin-left: 10px;
        margin-top: 2px;
        ${xScreen("lte", "sm")} {
            width: 50%;
            margin-top: 0;
        }
    `,
};

configureBudgetStyles.enforcementLevelGridItems = {
    width: 12,
    css: css`
        display: block;
        padding-bottom: 8px;
        ${xScreen("lte", "sm")} {
            padding-top: 10px;
        }
    `,
};

configureBudgetStyles.enforcementLevelLabel = {
    variant: "h5",
    css: css`
        display: inline-block;
        margin-right: 6px;
        margin-bottom: 0;
    `,
};

configureBudgetStyles.tableGridItems = {
    width: [12, 12, 12, 6, 6],
    css: css`
        padding: 15px 0 8px;
        & > div {
            overflow: unset;
        }
        ${xScreen("lte", "sm")} {
            padding: 15px 0;
        }
    `,
};

configureBudgetStyles.buttonsHidden = {
    css: css`
        width: 100%;
        display: flex;
        ${xScreen("lte", "sm")} {
            padding-top: 15px;
        }
    `,
};

configureBudgetStyles.budgetYearEndDatePicker = {
    cssOverrides: {
        formField: css`
            width: auto;
            margin-right: 35px;
            ${xScreen("lte", "sm")} {
                margin-top: 15px;
                margin-bottom: 5px;
            }
        `,
        datePicker: css`
            width: 100%;
            .react-datetime-picker__calendar {
                z-index: 1263;
            }
        `,
    },
};

configureBudgetStyles.enforcementLevel = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

configureBudgetStyles.twoButtonModalStyles = {
    modal: {
        sizeVariant: "medium",
        cssOverrides: {
            modalContent: css`
                &&& {
                    overflow: hidden;
                }
            `,
        },
    },
    submitButton: {
        color: "primary",
    },
};

configureBudgetStyles.clearDatePicker = {
    size: 18,
    css: css`
        color: ${color("primary")};
        vertical-align: middle;
    `,
};

configureBudgetStyles.removeCells = {
    css: css`
        vertical-align: middle;
    `,
};

configureBudgetStyles.removeIcon = {
    ...mergeWithCss(configureBudgetStyles.removeIcon, {
        css: css`
            &:hover {
                color: ${color("common.ui10")};
            }
        `,
    }),
};
